<template>
  <div>
    <div class="line"></div>
    <div :class="isSelected ? 'card--active' : false" class="card d-flex flex-column" :style="{'min-height': attr.minHeight}">
      <div :style="status == 'READY_TO_SEND' ? 'background-color: #e5e5e5;' : ''" class="card__main d-flex flex-column justify-content-between ">
        <!--<div class="card__header d-flex justify-content-between align-items-center ">
          <div class="flex-grow-1">
            <div class="card__title">
              <slot name="title"></slot>
            </div>
          </div>
          <div class="mx-3">
          </div>
          itemSelectedCard
          itemSelectedHeader
        </div>-->
        <div style class="headMainBox">
          <slot name="title"></slot>
        </div>
        <div class="card__body">
          <slot name="body"></slot>
        </div>
        <div class="card__footer" v-if="attr.hasFooter" :style="status == 'READY_TO_SEND' ? 'background-color: #e5e5e5;' : ''">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlowCard",
  props: {
    icon: {
      type: String
    },
    attr: {
      type: Object
    },
    isSelected: {
      type: Boolean
    },
    status: {
      type: String
    },
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.card {
  width: 250px;
  margin-bottom: 0px;
  border: solid 2px #d9e2ec;
  box-shadow: 0px 4px 5px 0 rgba(0, 0, 0, 0.3);
  border: solid 2px #d9e2ec;
  transition: 300ms;
  overflow: auto;

  &:hover,
  &--active {
    border-right: 1px solid var(--primary) !important;
    border-left: 1px solid var(--primary) !important;
    border-bottom: 1px solid var(--primary) !important;

    .headMainBox{
      background-color: var(--primary);
      color: #fff;
    }
  }

  &--minHeight {
    min-height: 240px;
  }

  &__preHeader {
    background-color: #e0e2e4;
    height: 40px;
  }

  &__header {
    min-height: 25px;
    background-color: #e0e2e4;
    font-size: 14px;
    text-align: center;
    color: #404347;
    padding-bottom: 20px;
    position: relative;

    > div {
      width: 20px;
    }
  }

  &__title {
  }

  &__body {
    padding: 20px;
    font-size: 12px;
  }

  &__footer {
    /*background-color: #e5e5e5; READY_TO_SEND*/
    min-height: 20px;
    font-size: 10px;

    div:not(:last-child) {
      border-right: 1px solid #d9e2ec;
    }
  }

  &__icon {
    &--card {
      max-width: 50px;
      transform: translateY(-20px);
    }

    &--edit {
      width: 20px;
    }
  }
}

.line {
  border-left: 3px solid #d1d4da;
  height: 60px;
  margin-left: 50%;
  position: relative;
}

.headMainBox {
  width: 100%;
  background-color: #edeff1;
  text-align: center;
  color: #a1a8b3;
  padding-bottom: 5px;
  padding-top: 5px;
  text-transform: uppercase;
}
</style>
